"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "@chakra-ui/react";
import CircleSpinner from "./CircleSpinner";
import { SpinnerType } from "./Spinner.types";
import SquareSpinner from "./SquareSpinner";
const Spinner = forwardRef(({ type = SpinnerType.CIRCLE, props }, ref) => {
    switch (type) {
        case SpinnerType.CIRCLE:
            return (_jsx(CircleSpinner, Object.assign({ ref: ref, speed: "1s" }, props)));
        default:
            return _jsx(SquareSpinner, Object.assign({ ref: ref }, props));
    }
});
Spinner.displayName = "Spinner";
export default Spinner;
//# sourceMappingURL=Spinner.js.map